import { Button, SyncAltIcon } from "@rothoblaas/design-system";
import { FC, memo } from "react";
import { useFormContext } from "react-hook-form";
import Icon from "../../../components/ui/Icon";
import useI18n from "../../../hooks/useTranslations";
import { ConcreteResinFormValues } from "../../../http/concreteResin/types/calculations";
import { UNIT_SYSTEM_IMPERIAL, UNIT_SYSTEM_METRIC } from "../../../types";
import { useIsImperial } from "./resinUnits";

type ConcreteResinUnitToggleProps = {
  // Passed in rather than read from --accent-base: the toggle is portaled into the page header,
  // outside the calculation grid that defines that variable.
  accentColor: string;
  disabled?: boolean;
};

// Shows the current unit system; clicking switches to the other one. Same look as the deck
// designer's toggle, but nothing to confirm: values stay in mm, so only how they're shown changes.
// Autosave persists the choice on the calculation.
const ConcreteResinUnitToggle: FC<ConcreteResinUnitToggleProps> = ({ accentColor, disabled }) => {
  const i18n = useI18n();
  const { setValue } = useFormContext<ConcreteResinFormValues>();
  const isImperial = useIsImperial();

  return (
    <Button
      type="button"
      variant="secondary"
      color={accentColor}
      disabled={disabled}
      // not marked dirty: no measurement changed, so a loaded saved entry stays highlighted
      onClick={() => setValue("unitSystem", isImperial ? UNIT_SYSTEM_METRIC : UNIT_SYSTEM_IMPERIAL)}
    >
      <Icon glyph={SyncAltIcon} />
      {isImperial
        ? i18n.translation.concreteResinModule.unitSystemImperial
        : i18n.translation.concreteResinModule.unitSystemMetric}
    </Button>
  );
};

export default memo(ConcreteResinUnitToggle);
